const navLinks = [
  {
    title: 'home',
    label: 'Home',
    url: '/',
    submenu: [],
  },
  {
    title: 'topics',
    label: 'Topics',
    url: '/topics',
    // submenu: [
    //   {
    //     title: 'Topic 1',
    //     label: 'Topic 1',
    //     url: 'topics/:id',
    //   },
    // ],
    submenu: [],
  },
  // ------NEW MENU ------
  {
    title: 'contents',
    label: 'Contents',
    url: '/',
    submenu: [
      {
        title: 'tips',
        label: 'Blogs',
        url: '/posts',
      },
      {
        title: 'action_lists',
        label: 'ActionList',
        url: '/action-lists',
      },
      {
        title: 'courses',
        label: 'Courses',
        url: '/courses',
      },
    ],
  },
  {
    title: 'directories',
    label: 'Directories',
    url: '/directories',
    // submenu: [
    //   {
    //     title: 'Directory 1',
    //     label: 'Directory 1',
    //     url: 'directories/:id',
    //   },
    // ],
    submenu: [],
  },
  {
    title: 'enterprise',
    label: 'Enterprise Directories',
    url: '/enterprise-directories',
    submenu: [],
  },
  {
    title: 'categories',
    label: 'Categories',
    url: '',
    submenu: [
      {
        label: 'Category 1',
        url: '/category/1',
      },
      {
        label: 'Category 2',
        url: '/category/2',
      },
      {
        label: 'Category 3',
        url: '/category/3',
      },
      {
        label: 'Category 4',
        url: '/category/4',
      },
      {
        label: 'Category 5',
        url: '/category/5',
      },
    ],
  },
  {
    title: 'about',
    label: 'About',
    url: '/about',
    submenu: [],
  },
];

export function getNavLinks() {
  return navLinks;
}
